import {
	Autocomplete,
	AutocompleteCollection,
	AutocompleteContent,
	AutocompleteEmpty,
	AutocompleteGroup,
	AutocompleteInput,
	AutocompleteItem,
	AutocompleteLabel,
	AutocompleteList,
	AutocompleteSeparator,
} from "@/components/ui/autocomplete";

interface LegalFormAutocompleteProps {
	value: string;
	onChange: (value: string) => void;
	legalForms: string[];
	"aria-invalid"?: boolean;
}

const COMMON_FORMS = [
	"Společnost s ručením omezeným (s.r.o.)",
	"Akciová společnost (a.s.)",
	"Podnikající osoba tuzemská (OSVČ)",
	"Veřejná obchodní společnost (v.o.s.)",
	"Společnost komanditní (k.s.)",
	"Družstvo",
	"Spolek",
];

function LegalFormAutocomplete({
	value,
	onChange,
	legalForms,
	"aria-invalid": ariaInvalid,
}: LegalFormAutocompleteProps) {
	const defaultItems = [
		{
			value: "Časté právní formy",
			items: COMMON_FORMS,
		},
		{
			value: "Ostatní právní formy",
			items: legalForms.filter((item) => !COMMON_FORMS.includes(item)),
		},
	];

	return value ? (
		<Autocomplete
			openOnInputClick={true}
			autoHighlight={true}
			items={legalForms}
			value={value}
			onValueChange={onChange}
		>
			<AutocompleteInput
				placeholder="Vyberte nebo napište právní formu"
				aria-invalid={ariaInvalid}
			/>
			<AutocompleteContent>
				<AutocompleteEmpty>Žádná právní forma nenalezena.</AutocompleteEmpty>
				<AutocompleteList>
					{(item) => (
						<AutocompleteItem key={item} value={item}>
							{item}
						</AutocompleteItem>
					)}
				</AutocompleteList>
			</AutocompleteContent>
		</Autocomplete>
	) : (
		<Autocomplete
			openOnInputClick={true}
			autoHighlight={true}
			items={defaultItems}
			value={value}
			onValueChange={onChange}
		>
			<AutocompleteInput
				placeholder="Vyberte nebo napište právní formu"
				aria-invalid={ariaInvalid}
			/>
			<AutocompleteContent>
				<AutocompleteEmpty>Žádná právní forma nenalezena.</AutocompleteEmpty>
				<AutocompleteList>
					{(group, index) => (
						<AutocompleteGroup key={group.value} items={group.items}>
							<AutocompleteLabel>{group.value}</AutocompleteLabel>
							<AutocompleteCollection>
								{(item) => (
									<AutocompleteItem key={item} value={item}>
										{item}
									</AutocompleteItem>
								)}
							</AutocompleteCollection>
							{index < defaultItems.length - 1 && <AutocompleteSeparator />}
						</AutocompleteGroup>
					)}
				</AutocompleteList>
			</AutocompleteContent>
		</Autocomplete>
	);
}

export { LegalFormAutocomplete };
